<template>
  <div>
    <v-card min-height="550">
      <v-dialog
        v-model="deleteWarningDialog"
        transition="dialog-top-transition"
        max-width="500"
      >
        <template>
          <v-card rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Warning
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="white--text"
                @click="deleteWarningDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text
              class="black--text pt-5 text-center"
              style="font-size: 20px"
            >
              <span> Are you sure ? </span>
            </v-card-text>
            <v-card-text
              class="black--text text-center"
              style="font-size: 14px"
            >
              Do you really want to delete this record ?
              <p class="mb-0">This process cannot be undone.</p>
            </v-card-text>
            <div class="mx-4">
              <v-divider></v-divider>
            </div>
            <v-card-actions class="px-4 py-5 justify-center">
              <div>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                  style="font-weight: 600"
                  @click="deleteWarningDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  @click="deleteRecord"
                  right
                  height="44"
                  color="error"
                  class="px-5"
                  style="font-weight: 600"
                >
                  Delete
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      <v-dialog v-model="breedingFormDialog" max-width="876px">
        <v-form
          ref="breedingForm"
          v-model="breedingFormValid"
          lazy-validation
          @submit.prevent="submitBreedingForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">Edit Current Record</div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeBreedingFormDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col cols="12" v-if="isEdit">
                  <v-card flat color="transparent">
                    <v-toolbar
                      class="bdr secondary2light"
                      :elevation="0"
                      outlined
                    >
                      <v-toolbar-title
                        class="grey--text text--darken-2"
                        style="font-size: 13px"
                      >
                        Do you really want to edit this record ? Your previous
                        records might get affected.
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-card>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Lastest Breeding Date
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        <span>{{
                          $t(
                            "animal.reproductionInfo.tooltip.latestBreedingDate"
                          )
                        }}</span></span
                      >
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="latestBreedingDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="breedingFormData.latest_breeding_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="latestBreedingDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="breedingFormData.latest_breeding_date"
                      @input="latestBreedingDateModel = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Pregnancy Status
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{
                        $t("animal.breedingTooltip.pregnancyDiagnosis")
                      }}</span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Status"
                    dense
                    v-model="breedingFormData.pregnancy_status"
                    :items="pregnancyStatus"
                    item-text="value"
                    item-value="id"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Last Calving Date
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t("animal.reproductionInfo.tooltip.lastCalvingDate")
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="lastCalvingDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="breedingFormData.last_calving_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="lastCalvingDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="breedingFormData.last_calving_date"
                      @input="lastCalvingDateModel = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeBreedingFormDialog"
              >
                Cancel
              </v-btn>

              <v-btn depressed color="primary" type="submit">
                <span v-if="isEdit">{{ $t("update") }}</span>
                <span v-else>{{ $t("submit") }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="heatDetectionDialog" max-width="876px">
        <v-form
          ref="heatDetectionForm"
          v-model="heatDetectionValid"
          lazy-validation
          @submit.prevent="submitHeatDetectionForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeHeatDetectionDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Estrous Date
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.estrousDate")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="estrousDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="heatDetectionFormData.estrous_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="estrousDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="heatDetectionFormData.estrous_date"
                      @input="estrousDateModel = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Estrous Time
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.reproductionInfo.tooltip.estruosTime") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="estrousDateTimeModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="heatDetectionFormData.estrous_time"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="estrousDateTimeModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="heatDetectionFormData.estrous_time"
                      @click:hour="estrousDateModel = false"
                      @input="estrousDateModel = false"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Estrous Signs
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.reproductionInfo.tooltip.estrousSigns") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Units"
                    dense
                    :items="estrousOptions"
                    item-text="value"
                    item-value="id"
                    v-model="heatDetectionFormData.estrous_signs"
                  ></v-select>
                </v-col>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Observed By
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{ $t("animal.reproductionInfo.tooltip.observedBy") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="heatDetectionFormData.observed_by"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeHeatDetectionDialog"
              >
                Cancel
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="breedingRecordFormDialog" max-width="876px">
        <v-form
          ref="breedingRecordForm"
          v-model="breedingRecordValid"
          lazy-validation
          @submit.prevent="submitBreedingRecordForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn
                icon
                class="white--text"
                @click="closeBreedingRecordDialog"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Breeding Method
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.breedingMethod")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Breeding Method"
                    dense
                    :items="breedingMethodOptions"
                    item-text="value"
                    item-value="id"
                    v-model="breedingRecordFormData.breeding_method"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Bull ID
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.reproductionInfo.tooltip.bullId") }}
                      </span>
                    </v-tooltip></label
                  >

                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="text"
                    v-model="breedingRecordFormData.bull_id"
                  ></v-text-field></v-col
                ><v-col class="py-0" sm="3">
                  <label class="label"
                    >Mating Period
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.matingPeriod")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="matingStartDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="breedingRecordFormData.mating_start_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="matingStartDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="breedingRecordFormData.mating_start_date"
                      @input="matingStartDateModel = false"
                    ></v-date-picker>
                  </v-menu> </v-col
                ><v-col class="py-0" sm="3">
                  <label class="label">{{ "." }}</label>
                  <v-menu
                    v-model="matingEndDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="breedingRecordFormData.mating_end_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="matingEndDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="breedingRecordFormData.mating_end_date"
                      @input="matingEndDateModel = false"
                    ></v-date-picker> </v-menu
                ></v-col>
                <v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 2
                  "
                >
                  <label class="label"
                    >Inseminator Name
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t("animal.reproductionInfo.tooltip.inseminatorName")
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="breedingRecordFormData.inseminator_name"
                  ></v-text-field> </v-col
                ><v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 2
                  "
                >
                  <label class="label"
                    >Straw Number
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.strawNumber")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    type="number"
                    :min="0"
                    oninput="this.value = Math.abs(this.value)"
                    v-model="breedingRecordFormData.straw_number"
                  ></v-text-field> </v-col
                ><v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method != 1
                  "
                >
                  <label class="label"
                    >Organization Name
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.organizationName")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="breedingRecordFormData.organization_name"
                  ></v-text-field> </v-col
                ><v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method != 1
                  "
                >
                  <label class="label"
                    >Bull Breed
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{ $t("animal.reproductionInfo.tooltip.bullBreed") }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Bull Breed "
                    dense
                    :items="breedOptions"
                    item-text="name"
                    item-value="id"
                    v-model="breedingRecordFormData.bull_breed"
                  ></v-select>
                </v-col>

                <v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 3
                  "
                >
                  <label class="label"
                    >Technician Name
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.technicalName")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="breedingRecordFormData.technician_name"
                  ></v-text-field>
                </v-col>

                <v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 3
                  "
                >
                  <label class="label"
                    >Surrogate Dam Breed
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.reproductionInfo.tooltip.surrogateDamBreed"
                          )
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="breedingRecordFormData.surrogate_dam_breed"
                  ></v-text-field>
                </v-col>

                <v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 3
                  "
                >
                  <label class="label"
                    >Surrogate Dam ID
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.surrogateDamId")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="breedingRecordFormData.surrogate_dam_id"
                  ></v-text-field>
                </v-col>
                <v-col
                  class="py-0"
                  sm="6"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 3
                  "
                >
                  <label class="label"
                    >Embryo ID
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.embryoId")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="breedingRecordFormData.embryo_id"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeBreedingRecordDialog"
              >
                Cancel
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="pregnancyFormDialog" max-width="876px">
        <v-form
          ref="pregnancyForm"
          v-model="pregnancyValid"
          lazy-validation
          @submit.prevent="submitPregnancyForm"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div v-if="isEdit && tableEdit">
                Edit Current Record
                <v-tooltip top color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{
                    ` Do you really want to edit this record ? Your previous records might get affected.`
                  }}</span>
                </v-tooltip>
              </div>
              <div v-else-if="isEdit">Edit Current Record</div>
              <div v-else>Add New Record</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closePregnancyFormDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label"
                    >Technician Name
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.technicalName")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="pregnancyFormData.technician_name"
                  ></v-text-field></v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Date
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t(
                            "animal.reproductionInfo.tooltip.pregnancyCheckDate"
                          )
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-menu
                    v-model="pregnancyDateModel"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="pregnancyFormData.pregnancy_date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-on:click:append="pregnancyDateModel = true"
                        placeholder="Select date"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="pregnancyFormData.pregnancy_date"
                      @input="pregnancyDateModel = false"
                    ></v-date-picker>
                  </v-menu> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Time
                    <!-- <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.reproductionInfo.microBiological.tooltip.californiaMastitis"
                          )
                        }}</span
                      >
                    </v-tooltip> -->
                  </label>
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="pregnancyFormData.pregnancy_time"
                  ></v-text-field> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Conception Status
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t("animal.reproductionInfo.tooltip.conceptionStatus")
                        }}
                      </span>
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="conceptionStatusData"
                    item-text="value"
                    item-value="id"
                    v-model="pregnancyFormData.conception_status"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Check Method
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t(
                            "animal.reproductionInfo.tooltip.pregnancyCheckMethod"
                          )
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-select
                    outlined
                    placeholder="Select Color"
                    dense
                    :items="pregnancyCheckMethod"
                    item-text="value"
                    item-value="id"
                    v-model="pregnancyFormData.check_method"
                  ></v-select> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Days Pregnant
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        {{
                          $t("animal.reproductionInfo.tooltip.daysPregnant")
                        }}</span
                      >
                    </v-tooltip></label
                  >
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="pregnancyFormData.days_pregnant"
                  ></v-text-field> </v-col
                ><v-col class="py-0" sm="6">
                  <label class="label"
                    >Remarks
                    <!-- <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span
                        >{{
                          $t(
                            "animal.reproductionInfo.microBiological.tooltip.antimicrobialResidues"
                          )
                        }}
                      </span>
                    </v-tooltip> -->
                  </label>
                  <v-text-field
                    outlined
                    placeholder="Enter Value"
                    dense
                    v-model="pregnancyFormData.remarks"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closePregnancyFormDialog"
              >
                Cancel
              </v-btn>
              <v-btn depressed color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <div class="d-flex mb-4 align-center">
        <h2>Fertility</h2>
        <v-spacer></v-spacer>
        <div>
          <v-btn
            height="50"
            width="300"
            color="primary"
            outlined
            v-show="!disableCurrentRecordButton"
            @click="startEdit(null)"
            >EDIT CURRENT RECORD</v-btn
          >
        </div>
        <div class="ml-5">
          <div class="d-flex justify-end">
            <v-btn
              height="50"
              width="200"
              @click="startCreate"
              dense
              depressed
              color="primary"
              :disabled="panel == undefined"
              >ADD NEW RECORD</v-btn
            >
          </div>
        </div>
      </div>

      <v-row justify="center">
        <v-expansion-panels
          class="mt-5"
          style="max-width: 97.5%"
          flat
          v-model="panel"
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>{{ $t("animal.reproductionInfo.breeding") }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Latest Breeding Date
                            <v-tooltip top color="black" max-width="350px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>
                                {{
                                  $t(
                                    "animal.reproductionInfo.tooltip.latestBreedingDate"
                                  )
                                }}
                              </span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingData &&
                              currentBreedingData.latest_breeding_date
                                ? formatDate(
                                    currentBreedingData.latest_breeding_date,
                                    "DD/MM/YYYY"
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Pregnancy Status
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("animal.breedingTooltip.pregnancyDiagnosis")
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingData
                                ? currentBreedingData?.pregnancy_status
                                  ? "Yes"
                                  : "No"
                                : "Not specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-icon class="float-right">mdi-dots-horizontal</v-icon>
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Last Calving Date
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.lastCalvingDate"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingData &&
                              currentBreedingData.last_calving_date
                                ? formatDate(
                                    currentBreedingData.last_calving_date,
                                    "DD/MM/YYYY"
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5">Breeding History</label>
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="breedingHeaders"
                  :items="breedingData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.latest_breeding_date="{ item }">
                    <div>
                      {{ item.latest_breeding_date | formatDate }}
                    </div>
                  </template>
                  <template v-slot:item.pregnancy_status="{ item }">
                    <div>
                      {{ item.pregnancy_status }}
                    </div>
                  </template>
                  <template v-slot:item.last_calving_date="{ item }">
                    <div>
                      {{ item.last_calving_date | formatDate }}
                    </div>
                  </template>
                  <template v-slot:item.observed_by="">
                    <div>
                      {{ getObservedBy() }}
                    </div>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>Heat Detection Record</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list class="green2">
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-subtitle
                              >Estrous Date
                              <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>{{
                                  $t(
                                    "animal.reproductionInfo.tooltip.estrousDate"
                                  )
                                }}</span>
                              </v-tooltip>
                            </v-list-item-subtitle>
                            <v-list-item-title class="text-h6 mt-2">
                              {{
                                currentHeatDetectionRecord &&
                                currentHeatDetectionRecord.estrous_date
                                  ? currentHeatDetectionRecord.estrous_date
                                  : "Not Specified"
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Estrous Time
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.estruosTime"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentHeatDetectionRecord &&
                              currentHeatDetectionRecord.estrous_time
                                ? formatTime(
                                    currentHeatDetectionRecord.estrous_time
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Estrous Signs
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.estrousSigns"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentHeatDetectionRecord &&
                              currentHeatDetectionRecord.estrous_signs
                                ? getEstrousSign(currentHeatDetectionRecord)
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Observed By
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("animal.reproductionInfo.tooltip.observedBy")
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentHeatDetectionRecord &&
                              currentHeatDetectionRecord.observed_by
                                ? currentHeatDetectionRecord.observed_by
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5">Heat Detection Record History</label>
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="heatDetectionHeaders"
                  :items="heatDetectionRecordData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.createdAt="{ item }">
                    <div>
                      {{ item.createdAt | formatDate }}
                    </div>
                  </template>
                  <template v-slot:item.estrous_time="{ item }">
                    <div>
                      {{ formatTime(item.estrous_time) }}
                    </div>
                  </template>

                  <template v-slot:item.estrous_signs="{ item }">
                    <div>
                      {{ getEstrousSign(item) }}
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>Breedings Records</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Breeding Method
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.breedingMethod"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.breeding_method
                                ? getBreedingMethodValue(currentBreedingRecord)
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Bull ID
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("animal.reproductionInfo.tooltip.bullId")
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.bull_id
                                ? currentBreedingRecord.bull_id
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Mating Period
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.matingPeriod"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.mating_start_date
                                ? formatDate(
                                    currentBreedingRecord.mating_start_date,
                                    "DD/MM/YYYY"
                                  )
                                : "Not Specified"
                            }}
                            -
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.mating_end_date
                                ? formatDate(
                                    currentBreedingRecord.mating_end_date,
                                    "DD/MM/YYYY"
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 2
                  "
                >
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Inseminator Name
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.inseminatorName"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.inseminator_name
                                ? currentBreedingRecord.inseminator_name
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 2
                  "
                >
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Straw Number
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.strawNumber"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.straw_number
                                ? currentBreedingRecord.straw_number
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method != 1
                  "
                >
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Organization Name
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.organizationName"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.organization_name
                                ? currentBreedingRecord.organization_name
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method != 1
                  "
                >
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Bull Breed
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("animal.reproductionInfo.tooltip.bullBreed")
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.bull_breed
                                ? getBullBreedValue(
                                    currentBreedingRecord.bull_breed
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 3
                  "
                >
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Technician Name
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.technicalName"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.technician_name
                                ? currentBreedingRecord.technician_name
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 3
                  "
                >
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Surrogate Dam ID
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.surrogateDamId"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.surrogate_dam_id
                                ? currentBreedingRecord.surrogate_dam_id
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                  v-if="
                    breedingRecordFormData.breeding_method &&
                    breedingRecordFormData.breeding_method == 3
                  "
                >
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Embryo ID
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t("animal.reproductionInfo.tooltip.embryoId")
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentBreedingRecord &&
                              currentBreedingRecord.embryo_id
                                ? currentBreedingRecord.embryo_id
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5"> Breeding Record History</label>
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="breedingRecordHeaders"
                  :items="breedingRecordData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.bull_breed="{ item }">
                    <div>
                      {{ getBullBreedValue(item.bull_breed) }}
                    </div>
                  </template>
                  <template v-slot:item.breeding_method="{ item }">
                    <div>
                      {{ getBreedingMethodValue(item) }}
                    </div>
                  </template>
                  <template v-slot:item.mating_start_date="{ item }">
                    <div>
                      {{ formatDate(item.mating_start_date, "DD/MM/YYYY") }}
                      -
                      {{ formatDate(item.mating_start_date, "DD/MM/YYYY") }}
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header class="subtitle-1">
              <span>Pregnancy Check Record</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row width="100%">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Technician Name
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.technicalName"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPregnancyCheckRecord &&
                              currentPregnancyCheckRecord.technician_name
                                ? currentPregnancyCheckRecord.technician_name
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content
                          ><v-list-item-subtitle
                            >Date
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.pregnancyCheckDate"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPregnancyCheckRecord &&
                              currentPregnancyCheckRecord.pregnancy_date
                                ? currentPregnancyCheckRecord.pregnancy_date
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Time
                            <!-- <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.pregnancyCheckDate"
                                )
                              }}</span>
                            </v-tooltip> -->
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPregnancyCheckRecord &&
                              currentPregnancyCheckRecord.pregnancy_time
                                ? currentPregnancyCheckRecord.pregnancy_time
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Conception Status
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.conceptionStatus"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPregnancyCheckRecord &&
                              currentPregnancyCheckRecord.conception_status
                                ? getConceptionStatus(
                                    currentPregnancyCheckRecord
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Check methods
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.pregnancyCheckMethod"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPregnancyCheckRecord &&
                              currentPregnancyCheckRecord.check_method
                                ? getPregnantCheckStatus(
                                    currentPregnancyCheckRecord
                                  )
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Days Pregnant
                            <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.tooltip.daysPregnant"
                                )
                              }}</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPregnancyCheckRecord &&
                              currentPregnancyCheckRecord.days_pregnant
                                ? currentPregnancyCheckRecord.days_pregnant
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="4">
                  <v-card class="pa-2 green2 elevation-0">
                    <v-list class="green2">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >Remarks
                            <!-- <v-tooltip top color="black" max-width="350">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>{{
                                $t(
                                  "animal.reproductionInfo.microBiological.tooltip.antimicrobialResidues"
                                )
                              }}</span>
                            </v-tooltip> -->
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{
                              currentPregnancyCheckRecord &&
                              currentPregnancyCheckRecord.remarks
                                ? currentPregnancyCheckRecord.remarks
                                : "Not Specified"
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
              <div>
                <label class="mt-5"> Pregnancy Check Record History</label>
                <v-data-table
                  class="mt-5 rounded-xl"
                  :headers="pregnancyCheckHeaders"
                  :items="pregnancyCheckData"
                  :items-per-page="20"
                  hide-default-footer
                  :loading="loading"
                  loading-text="Loading Data..."
                >
                  <template v-slot:item.createdAt="{ item }">
                    <div>
                      {{ item.createdAt | formatDate }}
                    </div>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-row>
                        <v-col sm="6">
                          <v-icon
                            dark
                            color="gray"
                            @click="
                              startEdit(item);
                              tableEdit = true;
                            "
                          >
                            mdi-pencil
                          </v-icon>
                        </v-col>
                        <v-col sm="6">
                          <v-icon dark color="red" @click="startDelete(item)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                  <template v-slot:footer></template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import moment from "moment";
import {
  getBreedingByAnimalId,
  getBreedingRecordByAnimalId,
  createBreeding,
  updateBreeding,
  updateBreedingRecord,
  createBreedingRecord,
  getHeatDetectionRecordByAnimalId,
  updateHeatDetectionRecord,
  createHeatDetectionRecord,
  getPregnancyCheckRecordByAnimalId,
  createPregnancyCheckRecord,
  updatePregnancyCheckRecord,
  deleteBreedingById,
  deleteHeatDetectionRecordById,
  deleteBreedingRecordById,
  deletePregnancyCheckRecordById,
} from "@/graphql/Reproduction.gql";

import { breeds } from "@/graphql/Animals.gql";

export default {
  apollo: {
    getBreedingByAnimalId: {
      query: getBreedingByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentBreedingData = data.getBreedingByAnimalId[0] || null;
          this.breedingData = data.getBreedingByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },

    breeds: {
      query: breeds,
      result({ data }) {
        this.breedOptions = data.breeds;
      },
    },

    getBreedingRecordByAnimalId: {
      query: getBreedingRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentBreedingRecord =
            data.getBreedingRecordByAnimalId[0] || null;
          this.breedingRecordData = data.getBreedingRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },

    getHeatDetectionRecordByAnimalId: {
      query: getHeatDetectionRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentHeatDetectionRecord =
            data.getHeatDetectionRecordByAnimalId[0] || null;
          this.heatDetectionRecordData = data.getHeatDetectionRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },

    getPregnancyCheckRecordByAnimalId: {
      query: getPregnancyCheckRecordByAnimalId,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentPregnancyCheckRecord =
            data.getPregnancyCheckRecordByAnimalId[0] || null;
          this.pregnancyCheckData = data.getPregnancyCheckRecordByAnimalId;
        }
      },
      update: (data) => {
        console.log(data);
      },
      error: (err) =>
        this.$notify({
          title: "Error loading data!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
  created() {
    console.log("treatment");
  },
  mixins: [generalMixin, loading],
  data() {
    return {
      latestBreedingDateModel: false,
      matingStartDateModel: false,
      estrousDateModel: false,
      estrousDateTimeModel: false,
      pregnancyDateModel: false,
      matingEndDateModel: false,
      lastCalvingDateModel: false,
      pregnancyValid: false,
      acidityRawMilkOrGravityValue: null,
      isMicroDialog: false,
      isPhysioDialog: false,
      loading: false,
      tableEdit: false,
      currentEditItem: null,
      editDialog: false,
      heatDetectionValid: false,
      breedingRecordValid: false,
      prognosisStartMenu: false,
      prognosisEndMenu: false,
      heatDetectionDialog: false,
      pregnancyFormDialog: false,
      breedingRecordFormDialog: false,
      nowDate: new Date().toISOString().slice(0, 10),
      deleteWarningDialog: false,
      currentBreedingData: null,
      currentBreedingRecord: null,
      pregnancyCheckHeaders: [
        {
          text: "Technician Name",
          align: "start",
          sortable: true,
          value: "technician_name",
        },
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "pregnancy_date",
        },
        {
          text: "Time",
          align: "start",
          sortable: true,
          value: "pregnancy_time",
        },
        {
          text: "Conception Status",
          align: "start",
          sortable: true,
          value: "conception_status",
        },
        {
          text: "Check Method",
          align: "start",
          sortable: true,
          value: "check_method",
        },
        {
          text: "Days Pregnant",
          align: "start",
          sortable: true,
          value: "days_pregnant",
        },
        {
          text: "Remarks",
          align: "start",
          sortable: true,
          value: "remarks",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      breedingHeaders: [
        {
          text: "Last Breeding Date",
          align: "start",
          sortable: true,
          value: "latest_breeding_date",
        },
        {
          text: "Pregnancy Status",
          align: "start",
          sortable: true,
          value: "pregnancy_status",
        },
        {
          text: "Last Calving Date",
          align: "start",
          sortable: true,
          value: "last_calving_date",
        },
        {
          text: "Observed By",
          align: "start",
          sortable: true,
          value: "observed_by",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      heatDetectionHeaders: [
        {
          text: "Estrous Date",
          align: "start",
          sortable: true,
          value: "estrous_date",
        },
        {
          text: "Estrous Time",
          align: "start",
          sortable: true,
          value: "estrous_time",
        },
        {
          text: "Estrous Signs",
          align: "start",
          sortable: true,
          value: "estrous_signs",
        },
        {
          text: "Observed By",
          align: "start",
          sortable: true,
          value: "observed_by",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      breedingRecordHeaders: [
        {
          text: "Breeding Method",
          align: "start",
          sortable: true,
          value: "breeding_method",
        },
        {
          text: "Bull ID",
          align: "start",
          sortable: true,
          value: "bull_id",
        },
        {
          text: "Mating Period",
          align: "start",
          sortable: true,
          value: "mating_start_date",
        },
        {
          text: "Inseminator Name",
          align: "start",
          sortable: true,
          value: "inseminator_name",
        },
        {
          text: "Straw Number",
          align: "start",
          sortable: true,
          value: "straw_number",
        },
        {
          text: "Organization Name",
          align: "start",
          sortable: true,
          value: "organization_name",
        },
        {
          text: "Bull Breed",
          align: "start",
          sortable: true,
          value: "bull_breed",
        },
        {
          text: "Technician Name",
          align: "start",
          sortable: true,
          value: "technician_name",
        },
        {
          text: "Embryo ID",
          align: "start",
          sortable: true,
          value: "embryo_id",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      breedingFormValid: false,
      breedingFormData: {},
      heatDetectionFormData: {},
      breedingRecordFormData: {},
      pregnancyFormData: {},
      breedingFormDialog: false,
      panel: 0,
      isEdit: false,
      breedingRecordData: [],
      heatDetectionRecordData: [],
      pregnancyCheckData: [],
      currentHeatDetectionRecord: [],
      currentPregnancyCheckRecord: [],
    };
  },
  methods: {
    changeEstrousTime() {
      this.heatDetectionFormData.estrous_time =
        this.heatDetectionFormData.estrous_date;
    },
    getConceptionStatus(item) {
      let conceptionData = this.conceptionStatusData.find(
        (data) => data.id == item.conception_status
      );
      return conceptionData.value ?? "Not-specified";
    },
    getPregnantCheckStatus(item) {
      let pregnancyCheckData = this.pregnancyCheckMethod.find(
        (data) => data.id == item.check_method
      );
      return pregnancyCheckData.value ?? "Not-specified";
    },
    getEstrousSign(item) {
      let estrousSignData = this.estrousOptions.find(
        (data) => data.id == item.estrous_signs
      );
      return estrousSignData.value ?? "Not Specified";
    },
    getBullBreedValue(breedId) {
      let breedData = this.breeds.find((data) => data.id == breedId);
      return breedData.name ?? "Not Specified";
    },
    getBreedingMethodValue(item) {
      let breedingData = this.breedingMethodOptions.find(
        (data) => data.id == item.breeding_method
      );

      return breedingData.value ?? "Not specified";
    },
    getObservedBy() {
      return (
        this.$store.getters.getUser.userDetail.firstName +
        " " +
        this.$store.getters.getUser.userDetail.lastName
      );
    },

    getEditRecord() {
      if (this.panel == 0) {
        return this.currentMilkRecord || this.breedingRecordData[0];
      } else if (this.panel == 1) {
        return this.currentPhysioRecord || this.heatDetectionRecordData[0];
      } else if (this.panel == 2) {
        return this.currentMicroRecord || this.microRecordData[0];
      }
    },
    closeEditConfirmation() {
      this.editDialog = false;
    },

    async deleteRecord() {
      if (this.panel == 0) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteBreedingById,
            variables: {
              id: Number(this.breedingFormData.id),
            },
          });
          this.$notify({
            title: `Record deleted successfully`,
            type: "success",
            position: "top right",
          });
          this.deleteWarningDialog = false;
          this.$apollo.queries.getBreedingByAnimalId.refetch();
          this.currentBreedingData = await this.breedingData[0];
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      } else if (this.panel == 1) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteHeatDetectionRecordById,
            variables: {
              id: Number(this.heatDetectionFormData.id),
            },
          });
          this.$apollo.queries.getHeatDetectionRecordByAnimalId.refetch();
          this.deleteWarningDialog = false;
          this.currentHeatDetectionRecord = await this
            .getHeatDetectionRecordByAnimalId[0];
          this.$notify({
            title: `Record Deleted Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      } else if (this.panel == 2) {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deleteBreedingRecordById,
            variables: {
              id: Number(this.breedingRecordFormData.id),
            },
          });
          this.$apollo.queries.getBreedingRecordByAnimalId.refetch();
          this.deleteWarningDialog = false;
          this.currentBreedingRecord = await this
            .getBreedingRecordByAnimalId[0];
          this.$notify({
            title: `Record Deleted Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      } else {
        this.startLoading();
        try {
          await this.$apollo.mutate({
            mutation: deletePregnancyCheckRecordById,
            variables: {
              id: Number(this.pregnancyFormData.id),
            },
          });
          this.$apollo.queries.deletePregnancyCheckRecordById.refetch();
          this.deleteWarningDialog = false;
          this.currentPregnancyCheckRecord = await this
            .deletePregnancyCheckRecordById[0];
          this.$notify({
            title: `Record Deleted Successfully`,
            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
        }
        this.stopLoading();
      }
    },
    startEdit(item) {
      this.editDialog = false;
      if (this.panel == 0) {
        this.isEdit = true;
        this.currentBreedingData = item || this.breedingData[0];
        this.breedingFormData = item || this.breedingData[0];
        this.breedingFormData.latest_breeding_date = this.breedingFormData
          .latest_breeding_date
          ? moment(this.breedingFormData.latest_breeding_date).format(
              "YYYY-MM-DD"
            )
          : null;

        this.breedingFormData.last_calving_date = this.breedingFormData
          .last_calving_date
          ? moment(this.breedingFormData.last_calving_date).format("YYYY-MM-DD")
          : null;

        this.breedingFormDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = true;
        this.currentHeatDetectionRecord =
          item || this.heatDetectionRecordData[0];
        this.heatDetectionFormData = item || this.heatDetectionRecordData[0];
        this.heatDetectionDialog = true;
      } else if (this.panel == 2) {
        this.isEdit = true;
        this.currentBreedingRecord = item || this.breedingRecordData[0];
        this.breedingRecordFormData = item || this.breedingRecordData[0];
        this.breedingRecordFormData.mating_start_date = this
          .breedingRecordFormData.mating_start_date
          ? moment(this.breedingRecordFormData.mating_start_date).format(
              "YYYY-MM-DD"
            )
          : null;
        this.breedingRecordFormData.mating_end_date = this
          .breedingRecordFormData.mating_end_date
          ? moment(this.breedingRecordFormData.mating_end_date).format(
              "YYYY-MM-DD"
            )
          : null;
        this.breedingRecordFormDialog = true;
      } else {
        this.isEdit = true;
        this.currentPregnancyCheckRecord = item || this.pregnancyCheckData[0];
        this.pregnancyFormData = item || this.pregnancyCheckData[0];
        this.pregnancyFormDialog = true;
      }
    },

    startDelete(item) {
      if (this.panel == 0) {
        this.breedingFormData = item;
        this.deleteWarningDialog = true;
      } else if (this.panel == 1) {
        this.heatDetectionFormData = item;
        this.deleteWarningDialog = true;
      } else if (this.panel == 2) {
        this.breedingRecordFormData = item;
        this.deleteWarningDialog = true;
      } else {
        this.pregnancyFormData = item;
        this.deleteWarningDialog = true;
      }
    },
    startCreate() {
      if (this.panel == 0) {
        this.isEdit = false;
        this.breedingFormData = {};
        this.breedingFormDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = false;
        this.heatDetectionFormData = {};
        this.heatDetectionFormData.observed_by = this.getObservedBy();
        this.heatDetectionDialog = true;
      } else if (this.panel == 2) {
        this.isEdit = false;
        this.breedingRecordFormData = { breeding_method: 1 };
        this.breedingRecordFormDialog = true;
      } else if (this.panel == 3) {
        this.isEdit = false;
        this.pregnancyFormData = {};
        this.pregnancyFormDialog = true;
      }
    },
    closeBreedingFormDialog() {
      this.breedingFormDialog = false;
      this.breedingFormData = false;
    },
    closeHeatDetectionDialog() {
      this.heatDetectionDialog = false;
      this.heatDetectionFormData = {};
    },
    closeBreedingRecordDialog() {
      this.breedingRecordFormDialog = false;
      this.breedingRecordFormData = {};
    },
    closePregnancyFormDialog() {
      this.pregnancyFormDialog = false;
      this.pregnancyFormData = {};
    },
    async submitPregnancyForm() {
      if (Object.keys(this.pregnancyFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.pregnancyFormData.animalId = Number(
        this.$route.params.animal_number
      );

      this.startLoading();
      if (this.isEdit) {
        delete this.pregnancyFormData.userId;
        delete this.pregnancyFormData.__typename;
        delete this.pregnancyFormData.is_deleted;
        this.pregnancyFormData.id = Number(this.pregnancyFormData.id);
        try {
          await this.$apollo.mutate({
            mutation: updatePregnancyCheckRecord,
            variables: {
              recordId: this.pregnancyFormData.id,
              pregnancyCheckinput: this.pregnancyFormData,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.pregnancyFormDialog = false;
          this.$apollo.queries.getPregnancyCheckRecordByAnimalId.refetch();
          this.currentPregnancyCheckRecord = this.pregnancyCheckData[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createPregnancyCheckRecord,
            variables: {
              pregnancyCheckinput: this.pregnancyFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.pregnancyFormDialog = false;
          this.$apollo.queries.getPregnancyCheckRecordByAnimalId.refetch();
          this.currentPregnancyCheckRecord = this.pregnancyCheckData[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },
    async submitBreedingForm() {
      if (Object.keys(this.breedingFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.breedingFormData.animalId = Number(this.$route.params.animal_number);

      this.startLoading();
      if (this.isEdit) {
        delete this.breedingFormData.userId;
        delete this.breedingFormData.__typename;
        delete this.breedingFormData.is_deleted;
        this.breedingFormData.id = Number(this.breedingFormData.id);
        try {
          await this.$apollo.mutate({
            mutation: updateBreeding,
            variables: {
              recordId: Number(this.breedingFormData.id),
              breedingInput: this.breedingFormData,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.breedingFormDialog = false;
          this.$apollo.queries.getBreedingByAnimalId.refetch();
          this.currentBreedingData = this.breedingData[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createBreeding,
            variables: {
              breedingInput: this.breedingFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.breedingFormDialog = false;
          this.$apollo.queries.getBreedingByAnimalId.refetch();
          this.currentBreedingData = this.breedingData[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },

    async submitBreedingRecordForm() {
      if (Object.keys(this.breedingRecordFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.breedingRecordFormData.animalId = Number(
        this.$route.params.animal_number
      );

      this.startLoading();
      if (this.isEdit) {
        delete this.breedingRecordFormData.userId;
        delete this.breedingRecordFormData.__typename;
        delete this.breedingRecordFormData.is_deleted;
        this.breedingRecordFormData.id = Number(this.breedingRecordFormData.id);
        try {
          await this.$apollo.mutate({
            mutation: updateBreedingRecord,
            variables: {
              recordId: this.breedingRecordFormData.id,
              breedingRecordInput: this.breedingRecordFormData,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.breedingRecordFormDialog = false;
          this.$apollo.queries.getBreedingRecordByAnimalId.refetch();
          this.currentBreedingRecord = this.milkReports[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createBreedingRecord,
            variables: {
              breedingRecordInput: this.breedingRecordFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.breedingRecordFormDialog = false;
          this.$apollo.queries.getBreedingRecordByAnimalId.refetch();
          this.currentBreedingRecord = this.breedingRecordData[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },

    async submitHeatDetectionForm() {
      if (Object.keys(this.heatDetectionFormData).length == 0) {
        this.$notify({
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.heatDetectionFormData.animalId = Number(
        this.$route.params.animal_number
      );

      this.startLoading();
      if (this.isEdit) {
        delete this.heatDetectionFormData.userId;
        delete this.heatDetectionFormData.__typename;
        delete this.heatDetectionFormData.is_deleted;
        this.heatDetectionFormData.id = Number(this.heatDetectionFormData.id);
        try {
          await this.$apollo.mutate({
            mutation: updateHeatDetectionRecord,
            variables: {
              recordId: this.heatDetectionFormData.id,
              heatDetectionInput: this.heatDetectionFormData,
            },
          });
          this.$notify({
            title: `Data updated successfully`,
            type: "success",
            position: "top right",
          });

          this.heatDetectionForm = false;
          this.heatDetectionDialog = false;
          this.$apollo.queries.getHeatDetectionRecordByAnimalId.refetch();
          this.currentHeatDetectionRecord = this.heatDetectionRecordData[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      } else {
        try {
          await this.$apollo.mutate({
            mutation: createHeatDetectionRecord,
            variables: {
              heatDetectionInput: this.heatDetectionFormData,
            },
          });
          this.$notify({
            title: `Data added successfully`,
            type: "success",
            position: "top right",
          });
          this.heatDetectionDialog = false;
          this.$apollo.queries.getHeatDetectionRecordByAnimalId.refetch();
          this.currentHeatDetectionRecord = this.heatDetectionRecordData[0];
        } catch (e) {
          this.stopLoading();
          this.closeBreedingFormDialog();
          // this.$notify({
          //   title: `Problem with data.`,
          //   text: e.message,
          //   type: "error",
          //   position: "top right",
          // });
        }
      }

      this.stopLoading();
    },

    formatTime(data) {
      return moment(data, "HH:mm").format("h:mm A");
    },
  },
  computed: {
    ...mapGetters([""]),
    estrousOptions() {
      return [
        { id: 1, value: "Mounting other cows" },
        { id: 2, value: "mucus discharge" },
        { id: 3, value: "swelling and reddened vulva" },
        { id: 4, value: "bellowing" },
        { id: 5, value: "restless" },
        { id: 6, value: "rubbed tail head hair" },
        { id: 7, value: "dirty flanks" },
        { id: 8, value: "chin resting and backrubbing" },
        { id: 9, value: "sniffing genitalia and head raising and lip curling" },
      ];
    },
    disableCurrentRecordButton() {
      if (this.panel == undefined) {
        return true;
      } else if (this.panel == 0 && !this.currentBreedingData) {
        return true;
      } else if (this.panel == 1 && !this.currentHeatDetectionRecord) {
        return true;
      } else if (this.panel == 2 && !this.currentBreedingRecord) {
        return true;
      } else if (this.panel == 3 && !this.currentPregnancyCheckRecord) {
        return true;
      } else {
        return false;
      }
    },
    acidityRawUnitOptions() {
      return ["pH"];
    },
    breedingMethodOptions() {
      return [
        { id: 1, value: "Natural" },
        { id: 2, value: "Artificial Insemination" },
        { id: 3, value: "Embryo Transfer" },
      ];
    },
    pregnancyStatus() {
      return [
        { id: true, value: "Yes" },
        { id: false, value: "No" },
      ];
    },
    conceptionStatusData() {
      return [
        { id: 1, value: "Pregnant" },
        { id: 2, value: "Not Pregnant" },
        { id: 3, value: "recheck" },
      ];
    },
    pregnancyCheckMethod() {
      return [
        {
          id: 1,
          value: "Manual palpation of the reproductive tract (per rectum)",
        },
        {
          id: 2,
          value: "Transrectal ultrasonography of the reproductive tract",
        },
        { id: 3, value: "Others" },
      ];
    },
  },
  mounted() {
    this.panel = 0;
  },
  watch: {
    refreshProp() {
      this.panel = 0;
    },
  },
  props: ["treatment", "refreshProp"],
};
</script>

<style lang="scss" scoped>
.v-expansion-panel {
  margin-top: 10px;
}
.v-expansion-panel-header {
  background: #f3f3f380;
  border-radius: 5px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

.card-border-content {
  color: var(--Secondary-1, #00bd73);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
}
.card-border-content-pointer {
  cursor: pointer;
}
</style>
